<template>
    <div class="text-center">
            <div class="d-flex justify-center my-14">
                <animated-icon size="174" :icon="icon" iconColor="primary" :backgroundColor="layout == 'portal' ? '#579FA71F' :'var(--v-primary-opacity-12)'"></animated-icon>
            </div>
            <slot>
                <div class="description">
                    <p>{{title}}</p>
                </div>
            </slot>
            <v-btn
                v-if="!hideButton"
                class="font-weight-bold secondary-font text-none my-6 px-16"
                color="primary"
                rounded
                outlined
                elevation="0"
                @click="redirect(redirectUrl)"
            >
                <div>{{buttonText}}</div>
            </v-btn>
        </div>
</template>

<script>
import AnimatedIcon from './AnimatedIcon.vue'

export default {
    components: { AnimatedIcon },
    props: {
        title: {
            required: false,
            default: '',
            type: String
        },
        icon: {
            required: false,
            default: 'fxt-heart',
            type: String
        },
        buttonText: {
            required: false,
            default: 'Neste',
            type: String
        },
        redirectUrl: {
            required: false,
            default: '',
            type: String
        },
        hideButton: {
            required: false,
            default: false,
            type: Boolean
        },
        layout: {
            required: false,
            default: 'chain',
            type: String
        }
    },
    methods: {
        redirect(url) {
            window.open(url, '_self')
        }
    }
}
</script>

<style scoped>
.description {
    font-weight: 400;
    font-size: 20px;
    line-height: 23px;
}
</style>